import { Customer } from '../models/customer.model';
export class AddCustomer {
    static readonly type = '[Customer] Add';

    constructor(public payload: Customer) {}
}

export class UpdateCustomerList {
    static readonly type = '[Customer] Update list';

    constructor(public payload: Customer[]) {}
}

export class RemoveCustomer {
    static readonly type = '[Customer] Remove';

    constructor(public payload: Customer) {}
}


export class ClearCustomer {
    static readonly type = '[Customer] Clear';

    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/actions/customer.action.ts